module.exports = __webpack_public_path__ + "99030ef53e9da243db953ba4dd71ab95.svg";